export default __webpack_public_path__ + "static/media/highway.f8c822b2.webp";